import { render } from "./Avatar.vue?vue&type=template&id=3ff6521e"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=3ff6521e&lang=css"
/* custom blocks */
import block0 from "./Avatar.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__